import { createAction } from '../../../../../store.model';
import { ChatBubble } from '../../model/chat-bubble.model';
import { ActionType } from '../teamschat-transcript-dialog.action';

export interface SelectQuotes {
    quotes: ChatBubble[];
    mode?: 'toggle-all' | 'set' | null | undefined;
}

export const selectQuotes = createAction<ActionType, SelectQuotes>(
    ActionType.COACHING_DETAIL__TCTD__SELECT_QUOTES,
);
